
import React from 'react'
import AuthorBlogTabs from './BlogTabs'
import { Breadcrumb } from 'antd'

const AuthorBlogPage: React.FC = () => {
  const [breadcrumb, setBreadcrumb] = React.useState("Author")
  return (
    <div className="mb-6">
      <h1 className="text-xl sm:text-3xl font-semibold sm:mb-1">Blogs</h1>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Blogs" }, { title: breadcrumb }]}
        />
      </div>
      <AuthorBlogTabs setBreadcrumb={setBreadcrumb} />
    </div>
  );
}

export default AuthorBlogPage